import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/trainingvideos/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";

import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({
  id,
  setId,
  show,
  showError,
  setShowError,
  setSuccess,
  setErr,
}) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    setError,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const videoFile = watch("video");
  const imageFile = watch("training_image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    console.log(data, "data");

    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("type", data?.type?.value);
      // sendData.append("description", data?.description);
      sendData.append("training_image", data?.training_image[0]);

      sendData.append("video", data?.video[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }

      console.log(response, "response");

      if (response?.meta?.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({ name: "" });
        setShowError("");
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
      if (response.meta.requestStatus === "rejected") {
        await setError("name", {
          type: "manual",
          message: "Training Video already exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  const type = [
    {
      id: "Cab",
      value: "Cab",
      label: "Cab",
    },
    {
      id: "Transport",
      value: "Transport",
      label: "Transport",
    },
    {
      id: "Share",
      value: "Share",
      label: "Share",
    },
  ];
  return (
    <>
      <Add_section_title
        title={id ? "Edit Training Video" : "Add Training Video"}
        alltotal=""
      />
      <div className="forms_section">
        <Form>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
                {showError && <span className="text-danger">{showError}</span>}
              </Form.Group>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Driver Type</Form.Label>
                <Controller
                  name="type" // name of the field
                  {...register("type", {
                    required: "Select Driver Type",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.type ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={type}
                    />
                  )}
                />
                {errors.type && (
                  <span className="text-danger">{errors.type.message}</span>
                )}
              </Form.Group>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Training Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.training_image,
                  })}
                  type="file"
                  {...register("training_image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("training_image") == "string"
                        ? false
                        : " Training Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.training_image && (
                  <span className="text-danger">
                    {errors.training_image.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-center">
                  Training Image Preview
                </Form.Label>

                {typeof getValues("training_image") === "string" ? (
                  // Preview for existing video from backend
                  <div className="video-preview-container">
                    <img
                      controls
                      width="300"
                      height="200"
                      src={IDS.IMG_URL + getValues("training_image")}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile.length > 0 && (
                    // Preview for newly uploaded video
                    <div className="video-preview-container">
                      <img
                        controls
                        width="300"
                        height="200"
                        src={URL.createObjectURL(imageFile[0])}
                      />
                    </div>
                  )
                )}
              </Form.Group>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Video</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.video,
                  })}
                  type="file"
                  {...register("video", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("video") == "string"
                        ? false
                        : " Training Video is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept="video/*"
                />
                {errors.video && (
                  <span className="text-danger">{errors.video.message}</span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-center">Video Preview</Form.Label>

                {typeof getValues("video") === "string" ? (
                  // Preview for existing video from backend
                  <div className="video-preview-container">
                    <video
                      controls
                      width="300"
                      height="200"
                      src={IDS.IMG_URL + getValues("video")}
                    />
                  </div>
                ) : (
                  videoFile &&
                  videoFile.length > 0 && (
                    // Preview for newly uploaded video
                    <div className="video-preview-container">
                      <video
                        controls
                        width="300"
                        height="200"
                        src={URL.createObjectURL(videoFile[0])}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({
                        name: "",
                        type: "",
                        description: "",
                      });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  {/* <button
                    type="button"
                    className="addbtn"
                    // onClick={handleSubmit(onSubmit)}
                    onClick={() => setModalShow(true)}
                  >
                    Submit
                  </button> */}
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
